import React from 'react';

import AkcionarSMS from 'components/pages/Akcionar/AkcionarSMS';
import HlasovaniAkcionar from 'components/pages/Akcionar/HlasovaniAkcionar';
import PrehledAkcionar from 'components/pages/Akcionar/PrehledAkcionar';
import RegistraceMajetku from 'components/pages/Akcionar/RegistraceMajetku';
import UdalostiAkcionar from 'components/pages/Akcionar/UdalostiAkcionar';
import CrsFormular from 'components/pages/Crs/CrsFormular';
import CrsHistorie from 'components/pages/Crs/CrsHistorie';
import CrsPrehled from 'components/pages/Crs/CrsPrehled';
import DetailUctu from 'components/pages/DetailUctu';
import DokumentPodpisSMS from 'components/pages/Dokumenty/DokumentPodpisSMS';
import DokumentyPrehled from 'components/pages/Dokumenty/DokumentyPrehled';
import HistorieDokumenty from 'components/pages/Dokumenty/HistorieDokumenty';
import NovyDokument from 'components/pages/Dokumenty/NovyDokument';
import loginSMS from 'components/pages/Dokumenty/loginSMS';
import OmezenaProveditelnost from 'components/pages/Dokumenty/omezenaProveditelnost/OmezenaProveditelnost';
import EmisePodaneZadosti from 'components/pages/Emise/PodaneZadosti';
import EmisePrehled from 'components/pages/Emise/PrehledEmise';
import PrehledUcty from 'components/pages/Emise/PrehledUcty';
import EmiseZmenyISIN from 'components/pages/Emise/ZmenaISIN/ZmenaISIN';
import EmiseNovyISIN from 'components/pages/Emise/novyISIN/NovyISIN';
import RegistraceISIN from 'components/pages/Emise/registraceISIN/RegistraceISIN';
import ListinneCp from 'components/pages/Emise/zaknihovaneEmise/ListinneCp';
import ZaknihovaneCp from 'components/pages/Emise/zaknihovaneEmise/ZaknihovaneCp';
import ErrPage from 'components/pages/ErrPage';
import { DetailKorporatniAkce } from 'components/pages/KorporatniAkce/DetailKorporatniAkce';
import { NovaUdalost } from 'components/pages/KorporatniAkce/NovaUdalost';
import { PrehledKorporatniAkce } from 'components/pages/KorporatniAkce/PrehledKorporatniAkce';
import { PruvodceVH } from 'components/pages/KorporatniAkce/PruvodceVH';
import { PruvodceVYPIS } from 'components/pages/KorporatniAkce/PruvodceVYPIS';
import DetailLei from 'components/pages/Lei/DetailLei';
import Faktury from 'components/pages/Lei/Faktury';
import PlatebniInstrukce from 'components/pages/Lei/PlatebniInstrukce';
import PrehledUctu from 'components/pages/Lei/PrehledUctu';
import SpravaUctu from 'components/pages/Lei/SpravaUctu';
import UdajeGleif from 'components/pages/Lei/UdajeGleif';
import KontaktZmena from 'components/pages/Lei/formularPages/KontaktZmena';
import NovyLei from 'components/pages/Lei/formularPages/NovyLei';
import UpravaLei from 'components/pages/Lei/formularPages/UpravaLei';
import PrevodLei from 'components/pages/Lei/prevodLei/PrevodLei';
import PopisSluzby from 'components/pages/Lei/seznamLei/PopisSluzby';
import PrideleneLeiPrehled from 'components/pages/Lei/seznamLei/PrideleneLeiPrehled';
import Faq from 'components/pages/Lei/zadostLeiLoginless/Faq';
import IdentifikaceOsoby from 'components/pages/Lei/zadostLeiLoginless/IdentifikaceOsoby';
import IdentifikaceSpolecnosti from 'components/pages/Lei/zadostLeiLoginless/IdentifikaceSpolecnosti';
import InfoLei from 'components/pages/Lei/zadostLeiLoginless/InfoLei';
import LeiLoginlessSearch from 'components/pages/Lei/zadostLeiLoginless/LeiLoginlessSearch';
import Onas from 'components/pages/Lei/zadostLeiLoginless/Onas';
import LeiObnoveniHesla from 'components/pages/LeiObnoveniHesla';
import LeiZadostObnovaHesla from 'components/pages/LeiZadostObnovaHesla';
import Login from 'components/pages/Login';
import Logout from 'components/pages/Logout';
import MainPage from 'components/pages/MainPage';
import MujProfil from 'components/pages/MujProfil';
import NovyUcet from 'components/pages/NovyUcet';
import ObnoveniHesla from 'components/pages/ObnoveniHesla';
import OvereniBankID from 'components/pages/OvereniBankID';
import Prehled from 'components/pages/Prehled';
import PxKlicLogin from 'components/pages/PxKlicLogin';
import RedirectLogin from 'components/pages/RedirectLogin';
import Registrace from 'components/pages/Registrace';
import RegistracePotvrzeni from 'components/pages/RegistracePotvrzeni';
import RozcestnikLogin from 'components/pages/RozcestnikLogin';
import DetailPozadavku from 'components/pages/SpecialniSluzby/DetailPozadavku';
import DetailPozadavkuDLT from 'components/pages/SpecialniSluzby/DetailPozadavkuDLT';
import HistorickePozadavky from 'components/pages/SpecialniSluzby/HistorickePozadavky';
import NovyPozadavek from 'components/pages/SpecialniSluzby/NovyPozadavek';
import NovyRucni from 'components/pages/SpecialniSluzby/NovyRucni';
import NovySoubor from 'components/pages/SpecialniSluzby/NovySoubor';
import PrehledSpecialniSluzby from 'components/pages/SpecialniSluzby/PrehledSpecialniSluzby';
import SeznamPozadavku from 'components/pages/SpecialniSluzby/SeznamPozadavku';
import SeznamPozadavkuDLT from 'components/pages/SpecialniSluzby/SeznamPozadavkuDLT';
import EvidencniUdaje from 'components/pages/SpravceUctu/EvidencniUdaje';
import PrehledSpravce from 'components/pages/SpravceUctu/PrehledSpravce';
import Uzivatele from 'components/pages/SpravceUctu/Uzivatele';
import { UcastnikPrehled } from 'components/pages/Ucastnik/UcastnikPrehled';
import ZadostObnovaHesla from 'components/pages/ZadostObnovaHesla';
import ZadostOkomunikaciLogin from 'components/pages/ZadostoKomunikaciLogin';
import ZmenaEmailuPotvrzeni from 'components/pages/ZmenaEmailuPotvrzeni';
import ZmenaHesla from 'components/pages/ZmenaHesla';
import ZmenaLogin from 'components/pages/ZmenaLogin';
import PrehledTextu from 'components/pages/editaceTextu/Prehled';
import PodaneZadosti from 'components/pages/elSluzbyPrehled/PodaneZadosti';
import PrideleneIsin from 'components/pages/elSluzbyPrehled/PrideleneIsin';
import RozpracovaneZadosti from 'components/pages/elSluzbyPrehled/RozpracovaneZadosti';
import ZpracovaneZadosti from 'components/pages/elSluzbyPrehled/ZpracovaneZadosti';
import HistorickeZadosti from 'components/pages/spravaEmitenta/HistorickeZadosti';
import OsobyAmlz from 'components/pages/spravaEmitenta/OsobyAMLZ';
import OsobyPrehled from 'components/pages/spravaEmitenta/OsobyPrehled';
import OsobyZasHistory from 'components/pages/spravaEmitenta/OsobyZasHistory';
import PrehledEmitent from 'components/pages/spravaEmitenta/PrehledEmitent';
import SpravaEmitentaPrehled from 'components/pages/spravaEmitenta/SpravaEmitentaPrehled';
import AgendaSMS from 'components/pages/spravaEmitenta/agendaAmlz/AgendaSMS';
import OsobyZastupujiciEmitenta from 'components/pages/spravaEmitenta/agendaAmlz/OsobyZastupujiciEmitenta';
import ZadostSpravaOsob from 'components/pages/spravaEmitenta/agendaAmlz/ZadostSpravaOsob';
import ZadostoAgenduAmlz from 'components/pages/spravaEmitenta/agendaAmlz/ZadostoAgenduAmlz';
import AmlzFormular from 'components/pages/spravaEmitenta/amlzFormular/AmlzFormular';
import PrehledUzivatelu from 'components/pages/spravaUzivatelu/PrehledUzivatelu';
import { UzivatelPage } from 'components/pages/spravaUzivatelu/Uzivatel';
import F1 from 'components/pages/statniSprava/F1';
import F1A from 'components/pages/statniSprava/F1A';
import F3 from 'components/pages/statniSprava/F3';
import F5 from 'components/pages/statniSprava/F5';
import F6 from 'components/pages/statniSprava/F6';
import F7 from 'components/pages/statniSprava/F7';
import F8 from 'components/pages/statniSprava/F8';
import F9 from 'components/pages/statniSprava/F9';
import F15 from 'components/pages/statniSprava/F15';
import F16 from 'components/pages/statniSprava/F16';
import F17 from 'components/pages/statniSprava/F17';
import F18 from 'components/pages/statniSprava/F18';
import F20 from 'components/pages/statniSprava/F20';
import F25 from 'components/pages/statniSprava/F25';
import F26 from 'components/pages/statniSprava/F26';
import F27 from 'components/pages/statniSprava/F27';
import F28 from 'components/pages/statniSprava/F28';
import F30 from 'components/pages/statniSprava/F30';
import F38 from 'components/pages/statniSprava/F38';
import F39 from 'components/pages/statniSprava/F39';
import F45 from 'components/pages/statniSprava/F45';
import F50 from 'components/pages/statniSprava/F50';
import F52 from 'components/pages/statniSprava/F52';
import F53 from 'components/pages/statniSprava/F53';
import F56 from 'components/pages/statniSprava/F56';
import F58 from 'components/pages/statniSprava/F58';
import MePozadavky from 'components/pages/statniSprava/MePozadavky';

import routePathEnum from 'enums/routePathEnum';

export interface IRouteMapa<T> {
    path: string; // Cesta vzata z enumu routePathEnum
    component: React.FC | React.ComponentType<T> | React.LazyExoticComponent<React.ComponentType<T>>; // Komponenty k zobrazení
    private?: boolean; // pouzit private = true pokud je potreba k pristupu token (prihlaseni)
}
export function routeMapa<T>(): IRouteMapa<T>[] {
    return [
        {
            component: MainPage,
            path: routePathEnum.MAIN_PAGE,
            private: true
        },
        {
            component: Login,
            path: routePathEnum.LOGIN_TOKEN
        },
        {
            component: RozcestnikLogin,
            path: routePathEnum.LOGIN_ROZCESTNIK
        },
        {
            component: RozcestnikLogin,
            path: routePathEnum.LOGIN_ROZCESTNIKDLT
        },
        {
            component: Login,
            path: routePathEnum.EMITENT_LOGIN_MUJDEP
        },
        {
            component: Login,
            path: routePathEnum.SRD_LOGIN_MUJDEP
        },
        {
            component: Login,
            path: routePathEnum.LOGIN_JINA_OSOBA
        },
        {
            component: Login,
            path: routePathEnum.STATNISPRAVA_LOGIN_MUJDEP
        },
        {
            component: Login,
            path: routePathEnum.LEI_LOGIN_MUJDEP
        },
        {
            component: PxKlicLogin,
            path: routePathEnum.PXKLIC_LOGIN
        },
        {
            component: Logout,
            path: routePathEnum.LOGOUT
        },
        {
            component: ErrPage,
            path: routePathEnum.REDIRECT_ERR
        },
        {
            component: AkcionarSMS,
            path: routePathEnum.AKCIONAR_SMS
        },
        {
            component: Registrace,
            path: routePathEnum.REGISTRACE
        },
        {
            component: RegistracePotvrzeni,
            path: routePathEnum.REGISTRACE_POTVRZENI
        },
        {
            component: RegistraceMajetku,
            path: routePathEnum.REGISTRACE_MAJETKU
        },
        {
            component: ZmenaHesla,
            path: routePathEnum.ZMENA_HESLA,
            private: true
        },
        {
            component: ZmenaLogin,
            path: routePathEnum.ZMENA_EMAILU_PROFIL,
            private: true
        },
        {
            component: LeiObnoveniHesla,
            path: routePathEnum.OBNOVENI_HESLA_LEI
        },
        {
            component: LeiZadostObnovaHesla,
            path: routePathEnum.ZADOST_OBNOVENI_HESLA_LEI
        },
        {
            component: PrideleneLeiPrehled,
            path: routePathEnum.LEI_PREHLED_UCTU
        },
        {
            component: PopisSluzby,
            path: routePathEnum.LEI_POPIS_SLUZBY
        },
        {
            component: ZadostObnovaHesla,
            path: routePathEnum.ZADOST_OBNOVENI_HESLA
        },
        {
            component: ObnoveniHesla,
            path: routePathEnum.OBNOVENI_HESLA
        },
        {
            component: ZmenaEmailuPotvrzeni,
            path: routePathEnum.ZMENA_EMAILU
        },
        {
            component: MujProfil,
            path: routePathEnum.MUJ_PROFIL,
            private: true
        },
        {
            component: NovyUcet,
            path: routePathEnum.NOVY_UCET,
            private: true
        },
        {
            component: PrehledUcty,
            path: routePathEnum.PROFIL_EMITENT_PREHLED,
            private: true
        },
        {
            component: Prehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED}`,
            private: true
        },
        {
            component: PrehledAkcionar,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_AKCIONAR}`,
            private: true
        },
        {
            component: UdalostiAkcionar,
            path: `${routePathEnum.FIRMA}${routePathEnum.UDALOSTI_AKCIONAR}`,
            private: true
        },
        {
            component: HlasovaniAkcionar,
            path: `${routePathEnum.FIRMA}${routePathEnum.HLASOVANI_AKCIONAR}`,
            private: true
        },
        {
            component: HlasovaniAkcionar,
            path: `${routePathEnum.FIRMA}${routePathEnum.HLASOVANI_SPRAVCE}`,
            private: true
        },
        /*  {
            component: HlasovaniAkcionar,
            path: `${routePathEnum.FIRMA}${routePathEnum.HLASOVANI_HROMADNE}`,
            private: true
        }, */
        {
            component: EmisePrehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMISE_PREHLED}`,
            private: true
        },
        {
            component: EmiseNovyISIN,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMISE_NOVY_ISIN}`,
            private: true
        },
        {
            component: RegistraceISIN,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMISE_REGI_ISIN}`,
            private: true
        },
        {
            component: EmiseZmenyISIN,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMISE_ZMENY_ISIN}`,
            private: true
        },
        {
            component: EmiseZmenyISIN,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMISE_ZRUSENI_ISIN}`,
            private: true
        },
        {
            component: EmisePodaneZadosti,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMISE_PODANE_ZADOSTI}`,
            private: true
        },
        {
            component: PrehledKorporatniAkce,
            path: `${routePathEnum.FIRMA}${routePathEnum.KORPORATNI_AKCE}`,
            private: true
        },
        {
            component: NovaUdalost,
            path: `${routePathEnum.FIRMA}${routePathEnum.NOVA_UDALOST}`,
            private: true
        },
        {
            component: DetailKorporatniAkce,
            path: `${routePathEnum.FIRMA}${routePathEnum.KORPORATNI_AKCE}${routePathEnum.DETAIL_KORPORATNI_AKCE_ID}`,
            private: true
        },
        {
            component: PruvodceVH,
            path: `${routePathEnum.FIRMA}${routePathEnum.NOVA_UDALOST}${routePathEnum.PRUVODCE_SRD_VH}`,
            private: true
        },
        {
            component: PruvodceVYPIS,
            path: `${routePathEnum.FIRMA}${routePathEnum.NOVA_UDALOST}${routePathEnum.PRUVODCE_SRD_VYPIS}`,
            private: true
        },
        {
            component: SpravaEmitentaPrehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_SPRAVA_EMITENTA}`,
            private: true
        },
        {
            component: PrehledEmitent,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_EMITENT}`,
            private: true
        },
        {
            component: PrehledEmitent,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_PRAVNICKA}`,
            private: true
        },
        {
            component: OsobyAmlz,
            path: `${routePathEnum.FIRMA}${routePathEnum.AMLZ_OSOBY}`,
            private: true
        },
        {
            component: HistorickeZadosti,
            path: `${routePathEnum.FIRMA}${routePathEnum.AMLZ_HISTORIE}`,
            private: true
        },
        {
            component: AmlzFormular,
            path: `${routePathEnum.FIRMA}${routePathEnum.AMLZ_FORMULAR}`,
            private: true
        },
        {
            component: ZadostoAgenduAmlz,
            path: `${routePathEnum.FIRMA}${routePathEnum.AMLZ_ZADOST_O_AGENDU}`,
            private: true
        },
        {
            component: AgendaSMS,
            path: `${routePathEnum.AMLZ_ZADOST_O_AGENDU}`,
            private: true
        },
        {
            component: ZadostOkomunikaciLogin,
            path: `${routePathEnum.AMLZ_ZADOST_O_AGENDU_LOGIN}`
        },
        {
            component: RedirectLogin,
            path: `${routePathEnum.REDIRECT_LOGIN_DLT}`
        },
        {
            component: RedirectLogin,
            path: `${routePathEnum.REDIRECT_LOGIN}`
        },
        {
            component: RedirectLogin,
            path: `${routePathEnum.LEI_LOGINLESS_ODKAZ}`
        },
        {
            component: RedirectLogin,
            path: `${routePathEnum.LEI_PLATBA_LOGIN}`
        },
        {
            component: OvereniBankID,
            path: `${routePathEnum.BANKID_OVERENI}`
        },
        {
            component: OsobyPrehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMITENT_ZASTUPUJICI_OSOBY}`,
            private: true
        },
        {
            component: ZadostSpravaOsob,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMITENT_ZASTUPUJICI_OSOBY_ZADOST}`,
            private: true
        },
        {
            component: OsobyZastupujiciEmitenta,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMITENT_ZASTUPUJICI_OSOBY_NOVA}`,
            private: true
        },
        {
            component: OsobyZastupujiciEmitenta,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMITENT_ZASTUPUJICI_OSOBY_EDITACE}`,
            private: true
        },
        {
            component: OsobyZasHistory,
            path: `${routePathEnum.FIRMA}${routePathEnum.EMITENT_ZASTUPUJICI_OSOBY_HISTORY}`,
            private: true
        },
        {
            component: OsobyPrehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.DLT_PO_ZASTUPUJICI_OSOBY}`,
            private: true
        },
        {
            component: ZadostSpravaOsob,
            path: `${routePathEnum.FIRMA}${routePathEnum.DLT_PO_ZASTUPUJICI_OSOBY_ZADOST}`,
            private: true
        },
        {
            component: OsobyZastupujiciEmitenta,
            path: `${routePathEnum.FIRMA}${routePathEnum.DLT_PO_ZASTUPUJICI_OSOBY_NOVA}`,
            private: true
        },
        {
            component: OsobyZastupujiciEmitenta,
            path: `${routePathEnum.FIRMA}${routePathEnum.DLT_PO_ZASTUPUJICI_OSOBY_EDITACE}`,
            private: true
        },
        {
            component: OsobyZasHistory,
            path: `${routePathEnum.FIRMA}${routePathEnum.DLT_PO_ZASTUPUJICI_OSOBY_HISTORY}`,
            private: true
        },
        {
            component: PrehledSpecialniSluzby,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_PREHLED_AKTIVNICH_POZADAVKU}`,
            private: true
        },
        {
            component: DetailPozadavku,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_DETAIL_POZADAVKU}`,
            private: true
        },
        {
            component: DetailPozadavkuDLT,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_DETAIL_POZADAVKU_DLT}`,
            private: true
        },
        {
            component: NovyRucni,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_VLOZENI_RUCNI}`,
            private: true
        },
        {
            component: NovySoubor,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_VLOZENI_SOUBOR}`,
            private: true
        },
        {
            component: NovyPozadavek,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_NOVY_UPIS}`,
            private: true
        },
        {
            component: NovyPozadavek,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_NOVY_UPIS_SICAV}`,
            private: true
        },
        {
            component: NovyPozadavek,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_NOVY_PREVOD}`,
            private: true
        },
        {
            component: NovyPozadavek,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_NOVY_NAVYSENI}`,
            private: true
        },
        {
            component: NovyPozadavek,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_NOVY_SICAV}`,
            private: true
        },
        {
            component: SeznamPozadavku,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_SEZNAM}`,
            private: true
        },
        {
            component: SeznamPozadavkuDLT,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_SEZNAM_DLT}`,
            private: true
        },
        {
            component: DetailPozadavku,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_SEZNAM_DVP}`,
            private: true
        },
        {
            component: HistorickePozadavky,
            path: `${routePathEnum.FIRMA}${routePathEnum.SLUZBY_HISTORICKE_POZADAVKY}`,
            private: true
        },
        {
            component: MePozadavky,
            path: `${routePathEnum.FIRMA}${routePathEnum.ME_POZADAVKY}`,
            private: true
        },
        {
            component: UcastnikPrehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_UCASTNIK}`,
            private: true
        },
        {
            component: PrehledSpravce,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_SPRAVCE}`,
            private: true
        },
        {
            component: PrehledSpravce,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_UCASTNIK_HLASOVANI}`,
            private: true
        },
        {
            component: F1,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F1}`,
            private: true
        },
        {
            component: F1A,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F1A}`,
            private: true
        },
        {
            component: F3,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F3}`,
            private: true
        },
        {
            component: F5,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F5}`,
            private: true
        },
        {
            component: F6,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F6}`,
            private: true
        },
        {
            component: F7,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F7}`,
            private: true
        },
        {
            component: F8,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F8}`,
            private: true
        },
        {
            component: F9,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F9}`,
            private: true
        },
        {
            component: F15,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F15}`,
            private: true
        },
        {
            component: F16,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F16}`,
            private: true
        },
        {
            component: F17,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F17}`,
            private: true
        },
        {
            component: F18,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F18}`,
            private: true
        },
        {
            component: F20,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F20}`,
            private: true
        },
        {
            component: F30,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F30}`,
            private: true
        },
        {
            component: F25,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F25}`,
            private: true
        },
        {
            component: F26,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F26}`,
            private: true
        },
        {
            component: F27,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F27}`,
            private: true
        },
        {
            component: F28,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F28}`,
            private: true
        },
        {
            component: F38,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F38}`,
            private: true
        },
        {
            component: F39,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F39}`,
            private: true
        },
        {
            component: F45,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F45}`,
            private: true
        },
        {
            component: F50,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F50}`,
            private: true
        },
        {
            component: F52,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F52}`,
            private: true
        },
        {
            component: F53,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F53}`,
            private: true
        },
        {
            component: F56,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F56}`,
            private: true
        },
        {
            component: F58,
            path: `${routePathEnum.FIRMA}${routePathEnum.STATNI_SPRAVA_F58}`,
            private: true
        },
        {
            component: PrevodLei,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_PREVOD}`,
            private: true
        },
        {
            component: NovyLei,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_NOVY}`,
            private: true
        },
        {
            component: SpravaUctu,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_SPRAVA}`,
            private: true
        },
        {
            component: UpravaLei,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_UPRAVA}`,
            private: true
        },
        {
            component: PrehledUctu,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI}`,
            private: true
        },
        {
            component: UdajeGleif,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_GLEIF}`,
            private: true
        },
        {
            component: DetailLei,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_DETAIL}`,
            private: true
        },
        {
            component: PlatebniInstrukce,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_PLATBA}`,
            private: true
        },
        {
            component: KontaktZmena,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_KONTAKT}`,
            private: true
        },
        {
            component: Faktury,
            path: `${routePathEnum.FIRMA}${routePathEnum.LEI_FAKTURY}`,
            private: true
        },
        {
            component: ZaknihovaneCp,
            path: `${routePathEnum.FIRMA}${routePathEnum.ZAKNIHOVANE_CP}`,
            private: true
        },
        {
            component: ListinneCp,
            path: `${routePathEnum.FIRMA}${routePathEnum.LISTINNE_CP}`,
            private: true
        },
        {
            component: EvidencniUdaje,
            path: `${routePathEnum.FIRMA}${routePathEnum.SPRAVA_UCTU_EVIDENCNI_UDAJE}`,
            private: true
        },
        {
            component: Uzivatele,
            path: `${routePathEnum.FIRMA}${routePathEnum.SPRAVA_UCTU_UZIVATELE}`,
            private: true
        },
        {
            component: PodaneZadosti,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_ZADOSTI_PODANE}`,
            private: true
        },
        {
            component: RozpracovaneZadosti,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_ZADOSTI_ROZPRACOVANE}`,
            private: true
        },
        {
            component: ZpracovaneZadosti,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_ZADOSTI_ZPRACOVANE}`,
            private: true
        },
        {
            component: PrideleneIsin,
            path: `${routePathEnum.FIRMA}${routePathEnum.PREHLED_ISIN_PRIDELENE}`,
            private: true
        },
        {
            component: DetailUctu,
            path: `${routePathEnum.DETAIL_UCTU}`,
            private: true
        },
        {
            component: UzivatelPage,
            path: `${routePathEnum.FIRMA}${routePathEnum.UZIVATELE_NOVY}`,
            private: true
        },
        {
            component: PrehledUzivatelu,
            path: `${routePathEnum.FIRMA}${routePathEnum.UZIVATELE_PREHLED}`,
            private: true
        },
        {
            component: PrehledTextu,
            path: `${routePathEnum.FIRMA}${routePathEnum.APLIKACNI_TEXTY}`,
            private: true
        },
        {
            component: DokumentyPrehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.DOKUMENTY_PREHLED}`,
            private: true
        },
        {
            component: NovyDokument,
            path: `${routePathEnum.FIRMA}${routePathEnum.DOKUMENTY_NOVY}`,
            private: true
        },
        {
            component: HistorieDokumenty,
            path: `${routePathEnum.FIRMA}${routePathEnum.DOKUMENTY_HISTORIE}`,
            private: true
        },
        {
            component: OmezenaProveditelnost,
            path: `${routePathEnum.FIRMA}${routePathEnum.DOKUMENTY_OMEZ_PREVOD}`,
            private: true
        },
        {
            component: CrsFormular,
            path: `${routePathEnum.FIRMA}${routePathEnum.CRS_DOTAZNIK_NOVY}`,
            private: true
        },
        {
            component: CrsPrehled,
            path: `${routePathEnum.FIRMA}${routePathEnum.CRS_DOTAZNIK_PREHLED}`,
            private: true
        },
        {
            component: CrsHistorie,
            path: `${routePathEnum.FIRMA}${routePathEnum.CRS_DOTAZNIK_HISTORIE}`,
            private: true
        },
        {
            component: loginSMS,
            path: `${routePathEnum.DOKUMENTY_LOGIN}`
        },
        {
            component: DokumentPodpisSMS,
            path: `${routePathEnum.DOKUMENTY_SMS}`,
            private: true
        },
        // lei loginless
        {
            component: LeiLoginlessSearch,
            path: routePathEnum.LEI_LOGINLESS_SEARCH
        },
        {
            component: Faq,
            path: routePathEnum.LEI_LOGINLESS_FAQ
        },
        {
            component: InfoLei,
            path: routePathEnum.LEI_LOGINLESS_INFO
        },
        {
            component: Onas,
            path: routePathEnum.LEI_LOGINLESS_ONAS
        },
        {
            component: IdentifikaceSpolecnosti,
            path: routePathEnum.LEI_LOGINLESS
        },
        {
            component: IdentifikaceOsoby,
            path: routePathEnum.LEI_LOGINLESS_OSOBA
        }
    ];
}
